export default __webpack_public_path__ + "static/media/logo.216c81ef.png";